module.exports = __webpack_public_path__ + "img/plus-light-blue.8155607d.svg";